/* eslint-disable */
import ToastComponent from "./toast.vue"
import { EventBus } from "./toastEventBus"

const defaultOptions = {
    closeButton: false,
    location: "top",      // Vuetify 3: location al posto di top/bottom/left
    timeOut: 4000,
    color: ""
}

const ToastPlugin = {
    install(app, options = {}) {

        const userOptions = { ...defaultOptions, ...options }

        // Registro il componente globalmente
        app.component("toast", ToastComponent)

        // Opzioni accessibili globalmente
        app.config.globalProperties.$toastOptions = userOptions

        // API del toast
        app.config.globalProperties.$toast = {

            alert(msg, par) {
                EventBus.emit("ToastMessage", { tipo: "alert", msg, par })
            },

            error(msg, par) {
                EventBus.emit("ToastMessage", { tipo: "error", msg, par })
            },

            info(msg, par) {
                EventBus.emit("ToastMessage", { tipo: "info", msg, par })
            },

            success(msg, par) {
                EventBus.emit("ToastMessage", { tipo: "success", msg, par })
            },

            close() {
                EventBus.emit("ToastMessage", { tipo: "", msg: "" })
            },

            update(msg) {
                EventBus.emit("ToastMessage", { tipo: "update", msg })
            }
        }
    }
}

export default ToastPlugin
